import { render, staticRenderFns } from "./FormSwitchBoxList.vue?vue&type=template&id=6c250354&"
import script from "./FormSwitchBoxList.vue?vue&type=script&lang=ts&"
export * from "./FormSwitchBoxList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports